<template lang="pug">
#menuContainer
    #Lego(v-bind:class="{ 'lego-top': isTop}" style="text-decoration: none")
        h1 {{title[year]}}
    h1.TitleB {{name}}
    .menuItem(v-for='item in menuList[year]' v-on:click="scroll_to(item.id)" v-bind:class="{ 'menu-top': isTop}") {{item.name}}
        #underline
    #drawer(v-if="drawerStatus")
        .drawerItem(v-for='(item,i) in menuList[year]' @click='opentheDrawer()')
            a(:href="'#'+item.name") {{item.name}}
                #underline
    .menuIcon(@click='opentheDrawer()' :class="menuclassList")
        .menuIconBar1
        .menuIconBar2
        .menuIconBar3
    a.toTopIcon(v-show="!isTop" :style="{'background-image': 'url(' + totopImg + ')'}" href='#')
</template>

<script>
export default {
    props: ['year'],
    data () {
        return {
            iconSrc: 'https://caepo.org/images/menu-logo.svg',
            title: {
                2026: 'MIMSVAI 2026',
                2025: 'MIMSVAI 2025',
                2024: 'MIMSVAI 2024',
                2023: 'MIMSVAI 2023',
                2022: 'MIMSVAI 2022',
                2021: 'MIMSVAI 2021'
            },
            menuList: {
                2026: [
                    {name: "ABOUT",id: "ABOUT"},
                    {name: "CALL FOR PAPERS",id: "PAPERS"},
                    {name: "KEYNOTE",id: "KEYNOTES"},
                    {name: "AGENDA",id: "AGENDA"},
                    {name: "ORGANIZER",id: "ORGANIZER"},
                    {name: "VENUE",id: "VENUE"}
                ],
                2025: [
                    {name: "ABOUT",id: "ABOUT"},
                    {name: "CALL FOR PAPERS",id: "PAPERS"},
                    {name: "KEYNOTES",id: "KEYNOTES"},
                    {name: "AGENDA",id: "AGENDA"},
                    {name: "ORGANIZER",id: "ORGANIZER"},
                    {name: "VENUE",id: "VENUE"}
                ],
                2024: [
                    {name: "ABOUT",id: "ABOUT"},
                    {name: "CALL FOR PAPERS",id: "PAPERS"},
                    {name: "KEYNOTES",id: "KEYNOTES"},
                    {name: "AGENDA",id: "AGENDA"},
                    {name: "ORGANIZER",id: "ORGANIZER"},
                    {name: "VENUE",id: "VENUE"}
                ],
                2023: [
                    {name: "ABOUT",id: "ABOUT"},
                    {name: "CALL FOR PAPERS",id: "PAPERS"},
                    {name: "KEYNOTES",id: "KEYNOTES"},
                    {name: "AGENDA",id: "AGENDA"},
                    {name: "ORGANIZER",id: "ORGANIZER"},
                    {name: "VENUE",id: "VENUE"}
                ],
                2022: [
                    {name: "ABOUT",id: "ABOUT"},
                    {name: "CALL FOR PAPERS",id: "PAPERS"},
                    {name: "KEYNOTES",id: "KEYNOTES"},
                    {name: "AGENDA",id: "AGENDA"},
                    {name: "ORGANIZER",id: "ORGANIZER"},
                    {name: "VENUE",id: "VENUE"}
                ],
                2021: [
                    {name: "ABOUT",id: "ABOUT"},
                    {name: "CALL FOR PAPERS",id: "PAPERS"},
                    {name: "KEYNOTES",id: "KEYNOTES"},
                    {name: "PANEL DISCUSSION",id: "PANEL"},
                    {name: "AGENDA",id: "AGENDA"},
                    {name: "ORGANIZER",id: "ORGANIZER"},
                    {name: "VENUE",id: "VENUE"}
                ]
            },
            drawerStatus: false,
            menuclassList: {
                menuIconContainer: true,
                change: false
            },
            name: 'Oppps',
            isTop: true,
            totopImg: 'https://mimsvai.github.io/static/imgs/toTopIcon.png'
        }
    },
    watch:{
        '$route': function(){
            this.name = this.$route.params.PID;
        }
    },
    mounted() {
        this.name = this.$route.params.PID;
        window.addEventListener('scroll', this.handleScroll)
    },
    methods: {
        opentheDrawer: function(){
            this.drawerStatus = !this.drawerStatus;
            this.menuclassList.change = !this.menuclassList.change;
        },
        handleScroll: function (evt, el) {
            if(window.scrollY>100){
                this.isTop = false;
            }
            else{
                this.isTop = true;
            }
        },
        scroll_to: function (id){
            var x_cood = document.getElementById(id).offsetTop;
            window.scrollTo(0, x_cood);

        }
    }
}

</script>

<style lang="sass">
@import "@/style/value.sass"

#Lego
    position: fixed
    left: 40px
    top: -5px
    transition: 0.8s
.lego-top
    top: 10px !important

#menuContainer
    position: fixed
    top: 0px
    right: 0px
    left: 0px
    display: flex
    flex-wrap: nowrap
    justify-content: flex-end
    padding: 10px
    background-color: #ffffffaa
    z-index: 1

.menuItem
    cursor: pointer
    margin-right: 15px
    margin-top: 10px
    transition: 0.8s
    font-weight: bold
.menu-top
    margin-top: 25px !important

.menuIcon
    cursor: pointer

.menuIconBar1, .menuIconBar2, .menuIconBar3
    width: 35px
    height: 3px
    background-color: $c-text
    transition: 0.3s
    margin: 8px
    position: relative
    border-radius: 25px
.change .menuIconBar1
    opacity: 0

.change .menuIconBar2
    -webkit-transform: rotate(-20deg) translate(-6px, 6px)
    transform: rotate(-20deg)

.change .menuIconBar3
    -webkit-transform: rotate(225deg)
    transform: rotate(225deg) translate(8px, 8px)
    transition-delay: 0.2s

#drawer
    background-color: #fff
    opacity: 0.9
    position: fixed
    text-align: center
    width: 100%
    right: 0px
    top: 0px
    bottom: 0px
    padding-top: 20%

.drawerItem
    cursor: pointer
    padding: 15px

@media all and (min-width: 960px)
    .menuItem
        opacity: 1
    .menuIcon,#drawer
        opacity: 0
        transition: 0.3s
        visibility: hidden
    #menuContainer
        position: fixed

@media all and (max-width: 960px)
    #menuContainer
        position: fixed
        height: 50px
    .menuItem
        opacity: 0
        transition: 0.3s
        visibility: hidden
    .menuIcon,#drawer
        opacity: 0.9

.toTopIcon
    position: fixed
    right: 50px
    bottom: 50px
    width: 45px
    height: 45px
    background-size: cover
</style>



// WEBPACK FOOTER //
// src/components/MenuM.vue